import React, { createContext, useContext, useState, useEffect } from "react";

const AppContext = createContext();

export function AppProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem("aavaa_user");
      return stored ? JSON.parse(stored) : null;
    } catch { return null; }
  });

  const [child, setChild] = useState(() => {
    try {
      const stored = localStorage.getItem("aavaa_child");
      return stored ? JSON.parse(stored) : null;
    } catch { return null; }
  });

  useEffect(() => {
    if (user) localStorage.setItem("aavaa_user", JSON.stringify(user));
    else localStorage.removeItem("aavaa_user");
  }, [user]);

  useEffect(() => {
    if (child) localStorage.setItem("aavaa_child", JSON.stringify(child));
    else localStorage.removeItem("aavaa_child");
  }, [child]);

  const logout = () => {
    setUser(null);
    setChild(null);
    localStorage.removeItem("aavaa_user");
    localStorage.removeItem("aavaa_child");
  };

  return (
    <AppContext.Provider value={{ user, setUser, child, setChild, logout }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  return useContext(AppContext);
}
